const ITEMS = [
  "1 & 2-Story Homes",
  "Storefronts",
  "Inside & Out",
  "Squeegee Detailed",
  "Per-Pane Pricing",
  "Zelle Accepted",
  "Locally Owned",
  "Naperville, IL",
];

const Row = ({ ariaHidden = false }) => (
  <div aria-hidden={ariaHidden} className="flex items-center shrink-0">
    {ITEMS.map((item, i) => (
      <span key={item} className="flex items-center shrink-0">
        <span
          className={`font-display italic text-3xl sm:text-5xl px-6 sm:px-10 whitespace-nowrap ${
            i % 2 === 0 ? "text-white/85" : "text-outline"
          }`}
        >
          {item}
        </span>
        <span className="w-2 h-2 rotate-45 bg-crystal/70 shrink-0" />
      </span>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      data-testid="marquee"
      className="relative border-y border-white/10 bg-ink/60 py-6 overflow-hidden mask-fade-x"
    >
      <div className="flex w-max animate-marquee">
        <Row />
        <Row ariaHidden />
      </div>
    </div>
  );
}
